"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFavouritesProvider = useFavouritesProvider;
/**
 *
 * FavouritesProvider
 *
 */
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const selectors_1 = require("../AccountProvider/selectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
function useFavouritesProvider() {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.favouritesProviderSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    const user = (0, react_redux_1.useSelector)(selectors_1.selectAccountUser);
    (0, react_1.useEffect)(() => {
        if (user) {
            dispatch(slice_1.favouritesProviderActions.fetchFavouriteEventsIds());
        }
    }, [dispatch, user]);
}
//# sourceMappingURL=useFavouritesProvider.js.map